module.exports = __webpack_public_path__ + "static/img/afternoon.1d6b446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/timelog/afternoon.png
// module id = ScoF
// module chunks = 0